import styled from 'styled-components';

import { Table } from '@gbs-monorepo-packages/common';

export const TableCustom = styled(Table)`
  width: 100%;
  margin-bottom: 0.5rem;
`;
